import React from 'react'
import PropTypes from 'prop-types'

const Spacer = props => (
  <div className='grid-x align-center'>
    <div className='xlarge-8 cell'>{props.children}</div>
  </div>
)

Spacer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.element),
  ]),
}

export default Spacer
